/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Regenerate_Token_DescriptionInputs */



/**
* | output |
* | --- |
* | "Generate a new SCIM token. The old token will be invalidated immediately." |
*
* @param {Scim_Regenerate_Token_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_regenerate_token_description = /** @type {((inputs?: Scim_Regenerate_Token_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Regenerate_Token_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Generieren Sie ein neues SCIM-Token. Das alte Token wird sofort ungültig.")
	return /** @type {LocalizedString} */ ("Generate a new SCIM token. The old token will be invalidated immediately.")
});